import CommonTooltip from "components/Tooltip/CommonTooltip";
import moment from "moment";
import { useEffect, useState } from "react";
import { getRandomColor } from "utils/getRandomColor";

import avatar5 from "../../../assets/img/avatar_5.svg";
import {
  DailyTime,
  TableBodyContainer,
  TableBodyItem,
  TableContainer,
  TableHeadContainer,
  TableHeadItem,
  TimeRangeText,
  TimesheetDate,
  TotalTimeContainer,
  WeeklyTotal,
} from "../../../styledComponents/timesheet";
import {
  formatHmsString,
  getHours,
  getHoursWithSeconds,
  toHHMMSS,
} from "../../../utils/helper";
import { HmsDisplay } from "../HmsDisplay";
import { TimeDisplay } from "../TimeDisplay";

const getTimes = date => {
  const times = [];
  let startDate = moment(date).startOf("week");
  while (moment(startDate).isSameOrBefore(moment(date).endOf("week"))) {
    times.push({
      date: startDate,
      hours: "0 h 0 m",
    });
    startDate = moment(startDate).add(1, "days");
  }
  return times;
};

const WeeklyMemberView = ({
  selectedDate,
  selectedMember,
  profileData,

  timesheetsList,
  getTimesheetDetails,
  detailsUserData,
  setDetailsUserData,
  activeDate,
  setActiveDate,
  selectedPanelDate,
  setSelectedPanelDate,
  isDetailsOpen,
}) => {
  const [timesheetsData, setTimesheetsData] = useState(null);

  const [bgColors, setBgColors] = useState({});

  useEffect(() => {
    const times = getTimes(selectedDate);
    const durations = [];
    if (timesheetsList && timesheetsList.length > 0) {
      timesheetsList.forEach(timesheet => {
        durations.push(timesheet.duration);
        times.some(item => {
          if (moment(item.date).format("YYYY-MM-DD") === timesheet.date) {
            item.hours = getHoursWithSeconds(toHHMMSS(timesheet.duration));
            return true;
          }
          return false;
        });
        if (
          detailsUserData &&
          detailsUserData.id === timesheet.user_id &&
          detailsUserData.date &&
          moment(detailsUserData.date).format("YYYY-MM-DD") === timesheet.date
        ) {
          setDetailsUserData({
            ...detailsUserData,
            totalTime: getHoursWithSeconds(toHHMMSS(timesheet.duration)),
          });
        }
      });
      setTimesheetsData({
        durations,
        timesheets: [...times],
      });
    } else if (timesheetsList && timesheetsList.length === 0) {
      setTimesheetsData({
        durations,
        timesheets: times,
      });
    }
  }, [timesheetsList]);

  useEffect(() => {
    setActiveDate(selectedPanelDate);
  }, [selectedPanelDate]);

  return (
    <>
      <TotalTimeContainer>
        <TimeRangeText>{`${moment(selectedDate)
          .startOf("week")
          .format("MMMM DD")} - ${moment(selectedDate)
          .endOf("week")
          .format("MMMM DD")}`}</TimeRangeText>
      </TotalTimeContainer>
      <TableContainer>
        <TableHeadContainer>
          {timesheetsData &&
            timesheetsData.timesheets &&
            timesheetsData.timesheets.length > 0 &&
            timesheetsData.timesheets.map((time, index) => (
              <TableHeadItem key={index}>
                {moment(time.date).format("ddd")}
              </TableHeadItem>
            ))}
          <TableHeadItem total>Total</TableHeadItem>
        </TableHeadContainer>
        <TableBodyContainer>
          {timesheetsData &&
            timesheetsData.timesheets &&
            timesheetsData.timesheets.length > 0 &&
            timesheetsData.timesheets.map((time, index) => {
              if (!bgColors[time.date]) bgColors[time.date] = getRandomColor();
              return (
                <TableBodyItem key={index}>
                  {time.hours === "0 h 00 m" || time.hours === "0 h 0 m" ? (
                    <DailyTime
                      backgroundColor="#EAF9F7"
                      isActive={
                        activeDate === moment(time.date).format("YYYY-MM-DD") &&
                        isDetailsOpen
                      }
                    >
                      -
                    </DailyTime>
                  ) : (
                    <DailyTime
                      backgroundColor="#EAF9F7"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        getTimesheetDetails(
                          time.date,
                          selectedMember
                            ? selectedMember.id
                            : localStorage.getItem("user_id"),
                        );
                        setDetailsUserData({
                          id: selectedMember
                            ? selectedMember.id
                            : localStorage.getItem("user_id"),
                          name: selectedMember
                            ? selectedMember.name
                            : profileData && profileData.id
                            ? `${profileData.first_name}${
                                profileData.last_name
                                  ? ` ${profileData.last_name}`
                                  : ""
                              }`
                            : null,
                          avatar: selectedMember
                            ? selectedMember.avatar
                              ? selectedMember.avatar
                              : avatar5
                            : profileData && profileData.thumbnail
                            ? profileData.thumbnail
                            : avatar5,
                          color: selectedMember
                            ? selectedMember.color
                            : profileData && profileData.color
                            ? profileData.color
                            : null,
                          date: time.date,
                          totalTime: time.hours,
                        });

                        setSelectedPanelDate(
                          moment(time.date).format("YYYY-MM-DD"),
                        );
                      }}
                      isActive={
                        activeDate === moment(time.date).format("YYYY-MM-DD") &&
                        isDetailsOpen
                      }
                      largerZ={isDetailsOpen}
                    >
                      <CommonTooltip tooltipText={formatHmsString(time.hours)}>
                        <TimeDisplay
                          timeString={time.hours}
                          marginLeft={"0px"}
                        />
                      </CommonTooltip>
                    </DailyTime>
                  )}
                  <TimesheetDate today={moment().isSame(time.date, "day")}>
                    {moment(time.date).format("MMM DD")}
                  </TimesheetDate>
                </TableBodyItem>
              );
            })}
          <TableBodyItem>
            <WeeklyTotal>
              {timesheetsData?.durations?.length > 0 ? (
                <CommonTooltip
                  tooltipText={formatHmsString(
                    getHoursWithSeconds(
                      toHHMMSS(
                        timesheetsData.durations
                          .slice(1)
                          .reduce(
                            (prev, cur) => prev + cur,
                            timesheetsData.durations[0],
                          ),
                      ),
                    ),
                  )}
                >
                  <TimeDisplay
                    timeString={getHoursWithSeconds(
                      toHHMMSS(
                        timesheetsData.durations
                          .slice(1)
                          .reduce(
                            (prev, cur) => prev + cur,
                            timesheetsData.durations[0],
                          ),
                      ),
                    )}
                    marginLeft="0px"
                  />
                </CommonTooltip>
              ) : (
                "-"
              )}
            </WeeklyTotal>
          </TableBodyItem>
        </TableBodyContainer>
      </TableContainer>
    </>
  );
};

export default WeeklyMemberView;
